export interface CookieOptions {
  expirationDays?: number
  path?: string
}

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  let cookie = `${name}=${value}`
  const { expirationDays, path } = options

  if (expirationDays != null) {
    const expire = new Date()
    expire.setDate(expire.getDate() + expirationDays)
    cookie += `;expires=${expire.toUTCString()}`
  }

  if (path != null) {
    cookie += `;path=${path}`
  }

  document.cookie = cookie
}

export const getCookie = (name: string): string | undefined => {
  const parts = `; ${document.cookie}`.split(`; ${name}=`)
  return parts.pop()?.split(';').shift()
}

export const cookieExists = (name: string): string | undefined => {
  return document.cookie
    .split(';')
    .find((c) => c.split('=')[0].trim() === name)
}
